import { resolveByCountry } from '@codex/helpers';

export function touchDeviceType(deviceType) {
  if (deviceType === 'tablet' || deviceType === 'mobile') {
    return true;
  }
  return false;
}


export function generatePriceFilterCheckboxesItems(priceFilterRanges, currentMinPrice, currentMaxPrice) {

  return priceFilterRanges.map((currentFilterRange) => ({
    label: currentFilterRange.label,
    value: {
      lowerRangeInclusive: currentFilterRange.lowerRangeInclusive,
      upperRangeInclusive: currentFilterRange.upperRangeInclusive,
      ...(currentFilterRange.upperRangeInclusive && { upperRangeInclusive: currentFilterRange.upperRangeInclusive })
    },
    selected: isFilterRangeSelected(currentFilterRange, priceFilterRanges, currentMinPrice, currentMaxPrice)
  }));
}

function isFilterRangeSelected(currentFilterRange, priceFilterRanges, currentMinPrice, currentMaxPrice) {

  if (typeof currentMinPrice !== 'number') {
    // no range is selected if currentMinPrice is not defined
    return false;
  }

  if (currentMinPrice === 0 && typeof currentMaxPrice !== 'number') {
    // if currentMinPrice is 0 and currentMaxPrice not defined, all price ranges are selected
    return true;
  }

  // branch for the case if currentFilterRange is the last range without upperRangeInclusive defined
  if (typeof currentFilterRange.upperRangeInclusive === 'undefined') {

    if (typeof currentMaxPrice === 'number') {
      // the last range can't be selected if currentMaxPrice is defined
      return false;
    }

    if (currentFilterRange.lowerRangeInclusive === currentMinPrice ||
      priceFilterRanges.findIndex((range) => range.lowerRangeInclusive === currentMinPrice) !== -1) {

      // the last range is selected when currentMinPrice is less then the last range
      // and some other filter range has lowerRangeInclusive equals to minPrice
      return true;
    }

    // the last range is not selected
    return false;
  }

  if (typeof currentMaxPrice !== 'number') {
    // branch if currentMaxPrice not defined and currentFilterRange has upperRangeInclusive defined

    if (currentFilterRange.lowerRangeInclusive >= currentMinPrice &&
      (currentFilterRange.lowerRangeInclusive === currentMinPrice ||
        priceFilterRanges.findIndex((range) => range.lowerRangeInclusive === currentMinPrice) !== -1)
    ) {
      // currentFilterRange is selected if its lowerRangeInclusive is equalled to currentMinPrice or currentMinPrice equals to
      // another range which is smaller than currentFilterRange

      return true;
    }
    return false;
  }


  if (currentFilterRange.lowerRangeInclusive >= currentMinPrice &&
    currentFilterRange.upperRangeInclusive <= currentMaxPrice &&
    priceFilterRanges.findIndex((range) => range.lowerRangeInclusive === currentMinPrice) !== -1 &&
    priceFilterRanges.findIndex((range) => range.upperRangeInclusive === currentMaxPrice) !== -1) {
    return true;
  }
  return false;
}

export function getPriceRangeFromFilterCheckboxesItems(filterCheckboxesItems) {

  let currentMinPrice;
  let currentMaxPrice;
  filterCheckboxesItems.forEach((currentCheckboxItem, index) => {
    if (currentCheckboxItem.selected && (typeof currentMinPrice === 'undefined')) {

      currentMinPrice = currentCheckboxItem.value.lowerRangeInclusive;
    }

    if (currentCheckboxItem.selected) {

      if (currentCheckboxItem.value.upperRangeInclusive) {
        currentMaxPrice = currentCheckboxItem.value.upperRangeInclusive;
      } else {
        currentMaxPrice = undefined;
      }
    }

  });

  if (typeof currentMinPrice === 'number') {
    return {
      currentMinPrice,
      ...(typeof currentMaxPrice === 'number' && { currentMaxPrice })
    };
  }

  return {};
}

export function getCurrentActivePriceFilterLabel(minPrice, maxPrice) {
  const currencySign = resolveByCountry('£', '€');

  return (
    maxPrice
      ? `${currencySign}${minPrice} - ` +
      `${currencySign}${maxPrice}`
      : `Over ${currencySign}${minPrice}` // TODO: add to translations
  );
}

export function getActiveFilterLabelsForRegularItem(values, useMobileSpecificLabel = false) {
  if (useMobileSpecificLabel) {
    return values.reduce((label, currentValue) => (
      label + (currentValue.selected ? `${label ? ', ' : ''}${currentValue.labelMobile
        ? currentValue.labelMobile
        : currentValue.value}` : '')
    ), '');
  }

  return values.reduce((label, currentValue) => (
    label + (currentValue.selected ? `${label ? ', ' : ''}${currentValue.label ? currentValue.label : currentValue.value}` : '')
  ), '');
}
